<!--
     <FilterAdvanced
       :filters='QFilters'
       @update="my_update_handler(QFilters)"
       disabled
     />
-->

<template>
  <div>
    <div 
      class="mb-2"
      align="center"
    >
      <v-divider></v-divider>
      <div
        v-if="!loading"
      >
        <v-btn
          @click.stop="showHeadFilters"
          :disabled="disabled || (dfields && dfields.length <= 0)"
          icon
          
        >
          <v-icon class="center" >{{ showFilterForm ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
        </v-btn>
        
      </div>
      <v-progress-circular
        v-else
        indeterminate
        color="primary"
        ></v-progress-circular>

    </div>
    <div
      v-if="showFilterForm && dfields && dfields.length > 0"
    >
      <FilterList
        ref="filter_list"
        :filters="advanced_filters"
        :filter_list="dfields"
        @update="update_filters"
      />
    </div> 
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import "@/sass/modalform.scss";
</style>
  
  
<script>
  import QUnit from '@/api/QUnit'
  import { QFilters, get_qfilter, url_to_filters } from '@/qunit/filters';
  
  export default {
    components: {
      FilterList: () => import('@/components/explorer/filters/FilterList'),
    },
  
    name: 'AdvancedFilter',
  
    props: {
      filters: {
        type: QFilters,
        required: true,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      is_mobile: {
        type: Boolean, 
        default: false
      },
      props: {
        default: () => ({})
      }
    },
  
    data: () => ({
      filter_fields_to_collect: [],
      showFilterForm: false,
      dfields: null,
      raw_fields: null,
      advanced_filters: new QFilters(),
      loading: false,
    }),
  
    computed: {
      business_process() {
        return this.filters.get_filter_value('business_process');
      },
  
      centro_id() {
        return this.filters.get_filter_value('centro');
      },
  //RelatedSelect
      active() {
        // return Object.keys(this.filters.advanced_filters||{}).length > 0;
        return Object.values(this.filters.get_filter_value('advanced_filters')||{}).some((elem) => elem != undefined)
      },
    },
  
    mounted() {
      this.pull_filters();
    },
  
    methods: {
      close() {
        this.showFilterForm = false;
      },
  
      cancelHeadFilters() {
        this.$refs.dform.clear();
      },
  
      setHeadFilters() {
        const form_data = this.$refs.dform.get_data();
        const values = {};
 
        for (const field of this.filter_fields_to_collect) {
          values[field.id] = undefined;
        }
        for (const [key, value] of form_data) {
          values[key] = value;
        }
        let filters = new QFilters();
        filters.set_filter(get_qfilter('advanced_filters',values));
        this.$emit("update", filters);
  
        this.close();     
      },
  
      async query_fields() {
        if (! this.business_process) {
          this.set_filter_fields_to_collect();
        } else {
          this.loading = true;
          const data = await QUnit.getFieldsToCollectForFiltering(this.centro_id, this.business_process);
          this.set_filter_fields_to_collect(data.fields);
          this.loading = false;
        }
      },
  
      showHeadFilters() {
        //this.showFilterForm = true;
        this.showFilterForm = !this.showFilterForm;
      },
  
      set_filter_fields_to_collect(fields) {
        this.raw_fields = fields;
        this.update_fields_values();
      },
  
      update_fields_values() {
        this.filter_fields_to_collect = [];
        const adv_filters = this.filters.get_filter_value('advanced_filters')
        // Reflect active filters:
        for (const field of (this.raw_fields || [])) {
          if (field.component != "RelatedSelect"){
            this.filter_fields_to_collect.push({
              ...field,
              value: (adv_filters && adv_filters[field.id]) ? adv_filters[field.id] : undefined,
              cols: 12,
            });
          }
        }
        this.dfields = [...this.filter_fields_to_collect]
      },
  
      pull_filters() {
        const adv_filters = this.filters.get_filter_value('advanced_filters');
        this.advanced_filters = url_to_filters(adv_filters)

        this.update_fields_values();
        this.query_fields();
      },

      get_value() {
        let filters = new QFilters();
        filters.set_filter(get_qfilter('advanced_filters',this.advanced_filters.as_query()));
        return filters;
      },

      update_filters(filter) {
        this.advanced_filters.set_filter(filter);
        this.$emit('update',this.get_value())
      }
    },
  
    watch: {
      filters() {
        this.pull_filters();
      },
    }
  }
</script>
  